import { useModal } from '@ebay/nice-modal-react'
import { Registry } from 'src/types/registry'
import { RegItem } from 'src/types/regItem'
import { useOpenCreateEditReservationModal } from '../../hooks/useOpenCreateEditReservationModal'

export const useGetHandlePurchasedCheckboxClicked = (
  regItem: RegItem,
  registry: Registry
) => {
  const modal = useModal()
  const openCreateEditReservationModal = useOpenCreateEditReservationModal({
    regItem,
    registry,
  })

  return () => {
    modal.hide()
    openCreateEditReservationModal()
  }
}
